import { Box, Button, Grid, Link, Typography } from '@mui/material';
import React, {
  Dispatch,
  ReducerAction,
  useContext,
  useEffect,
  useReducer,
} from 'react';
import LaunchDarklyContext from '../../../shared-components/contexts/LaunchDarklyContext';
import UserContext from '../../../shared-components/contexts/UserContext';
import UserService from '../../../shared-services/User/UserService';
import UserManagementContentPanel from './Components/UserManagementContentPanel';
import UserManagementFilterPanel from './Components/UserManagementFilterPanel';
import {
  IUserManagementState,
  userManagementInitialState,
} from './Interfaces/IUserManagementState';
import { UserManagementActionType } from './Types/UserManagementActionType';
import { UserManagementReducer } from './UserManagementReducer';

export const UserManagementDispatch = React.createContext(
  {} as Dispatch<ReducerAction<typeof UserManagementReducer>>,
);

export const UserManagementState = React.createContext(
  {} as IUserManagementState,
);

const UserManagement = () => {
  const user = useContext(UserContext);
  const [state, dispatch] = useReducer(
    UserManagementReducer,
    userManagementInitialState(),
  );

  return (
    <UserManagementDispatch.Provider value={dispatch}>
      <UserManagementState.Provider value={state}>
        <Grid container>
          <Grid item xs={6}>
            <Typography variant="h1" id="user-management-header">
              User Management
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {user.isAdministrator && (
              <Box
                display="flex"
                justifyContent="flex-end"
                style={{ marginTop: '7px' }}
              >
                <Link href="/beacon/settings/connections/import">
                  <Button variant="contained" color="primary">
                    Import Connections
                  </Button>
                </Link>
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item md={12} lg={4}>
            <UserManagementFilterPanel />
          </Grid>
          <Grid item md={12} lg={8}>
            <UserManagementContentPanel />
          </Grid>
        </Grid>
      </UserManagementState.Provider>
    </UserManagementDispatch.Provider>
  );
};

export default UserManagement;
